import { ActionTree, ActionContext } from 'vuex';
import { OrderApi } from '@/api/order-api';
import { OrderFilters } from '@/models/order-filters';
import { Mutations } from '@/stores/orders/mutation-constants';
import { State } from '@/stores/orders/state';
import { Forbidden } from '@/models/forbidden-error';
import { NotFound } from '@/models/not-found-error';
import router from '@/router';

const api = new OrderApi();

export class Actions implements ActionTree<State, any> {
    [key: string]: ((injectee: ActionContext<State, any>, payload: any) => any);

    public fetchAsync = async (context: ActionContext<State, any>, filters: OrderFilters) => {
        try {
            const result = await api.fetchAsync(filters);
            context.commit(Mutations.SetOrders, result.orders);
            // context.commit(Mutations.SetCurrentPageSize, result.pageSize);
            context.commit(Mutations.SetTotalPages, Math.ceil(result.total / ((result.pageSize < 1) ? 1 : result.pageSize)));
            context.commit(Mutations.SetTotalOrders, result.total);
        } catch (e) {
            if (e instanceof Forbidden) {
                router.push({ name: 'forbidden' });
            }
            if (e instanceof NotFound) {
                router.push({ name: 'not-found' });
            }
        }
    }
    public updateFilterStatus = (context: ActionContext<State, any>, value: number | string | null) => {
        context.commit(Mutations.SetFilterStatus, value);
    }
    public updatePage = (context: ActionContext<State, any>, value: number) => {
        context.commit(Mutations.SetPage, value);
    }
    public updateFrom = (context: ActionContext<State, any>, value: string | null) => {
        context.commit(Mutations.SetFrom, value);
    }
    public updateTo = (context: ActionContext<State, any>, value: string | null) => {
        context.commit(Mutations.SetTo, value);
    }
}
